import { render, staticRenderFns } from "./MsgElementVideo.vue?vue&type=template&id=1ed8a9c0&scoped=true"
import script from "./MsgElementVideo.vue?vue&type=script&lang=js"
export * from "./MsgElementVideo.vue?vue&type=script&lang=js"
import style0 from "./MsgElementVideo.vue?vue&type=style&index=0&id=1ed8a9c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed8a9c0",
  null
  
)

export default component.exports